import { render, staticRenderFns } from "./PayDashboard.vue?vue&type=template&id=d5b7890a&scoped=true&"
import script from "./PayDashboard.js?vue&type=script&lang=js&"
export * from "./PayDashboard.js?vue&type=script&lang=js&"
import style0 from "./PayDashboard.scss?vue&type=style&index=0&id=d5b7890a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b7890a",
  null
  
)

export default component.exports